import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  retrieveProject,
  selectProject,
  selectRetrieveProjectState,
} from '../../modules/projects.js';
import {
  retrieveFiles,
  selectFiles,
  selectIsSearching,
  selectSearchRetrieveFilesState,
} from '../../modules/files.js';
import ProjectFiles from '../../components/projects/ProjectFiles.jsx';
import ProjectHeader from '../../components/headers/PageHeaders/Project/ProjectHeader.jsx';

const mapStateToProps = (state, ownProps) => ({
  project: selectProject(ownProps.projectId)(state),
  retrieveProjectSuccess: selectRetrieveProjectState(state).success,
  files: selectFiles(state),
  isSearching: selectIsSearching(state),
  searchRetrieveState: selectSearchRetrieveFilesState(state),
});

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      retrieveProject: () => retrieveProject(ownProps.projectId, false),
      retrieveFiles: () => retrieveFiles(ownProps.projectId),
    },
    dispatch
  );

function ProjectFilesContainer({
  files,
  project,
  isSearching,
  searchRetrieveState,
  retrieveFiles,
  retrieveProject,
  retrieveProjectSuccess,
}) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    retrieveProject();
    retrieveFiles().then(() => setLoading(false));
  }, [retrieveFiles, retrieveProject]);

  return (
    retrieveProjectSuccess && (
      <>
        <ProjectHeader project={project} />
        <ProjectFiles
          loading={loading}
          project={project}
          files={files}
          isSearching={isSearching}
          searchRetrieveState={searchRetrieveState}
        />
      </>
    )
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProjectFilesContainer);
